'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = ContactMapDetails;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EmailIcons = require('../EmailIcons');

var _ContactMapDetails = require('./ContactMapDetails.style');

var _ContactMapDetails2 = _interopRequireDefault(_ContactMapDetails);

var _DefaultElement = require('oy-vey/lib/components/DefaultElement.js');

var _DefaultElement2 = _interopRequireDefault(_DefaultElement);

var _wixrestUtils = require('@wix/wixrest-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = _DefaultElement2.default.Table,
    TBody = _DefaultElement2.default.TBody,
    TR = _DefaultElement2.default.TR,
    TD = _DefaultElement2.default.TD;
function ContactMapDetails(_ref) {
    var i18n = _ref.i18n,
        address = _ref.address,
        addressLink = _ref.addressLink,
        phone = _ref.phone,
        name = _ref.name,
        fontFamily = _ref.fontFamily,
        nameFontSize = _ref.nameFontSize,
        countryCode = _ref.countryCode;

    var _styles = (0, _ContactMapDetails2.default)(i18n.getDir() === 'rtl', fontFamily, nameFontSize);
    var addressEl = addressLink ? _react2.default.createElement(
        'a',
        { style: _styles.linkStyle, href: addressLink, target: '_blank' },
        address
    ) : address;

    return _react2.default.createElement(
        Table,
        null,
        _react2.default.createElement(
            TBody,
            null,
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    { style: _styles.name, colSpan: 2 },
                    _react2.default.createElement(
                        'span',
                        { 'data-hook': 'rest-name' },
                        name
                    )
                )
            ),
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    { style: _styles.icon },
                    _react2.default.createElement(_EmailIcons.BgLocationIcon, null)
                ),
                _react2.default.createElement(
                    TD,
                    null,
                    _react2.default.createElement(
                        'div',
                        { style: _styles.contactDetail, 'data-hook': 'rest-address' },
                        addressEl
                    )
                )
            ),
            _react2.default.createElement(
                TR,
                null,
                _react2.default.createElement(
                    TD,
                    { style: _styles.icon },
                    _react2.default.createElement(_EmailIcons.BgPhoneIcon, null)
                ),
                _react2.default.createElement(
                    TD,
                    null,
                    _react2.default.createElement(
                        'div',
                        { style: (0, _extends3.default)({}, _styles.contactDetail, _styles.contactDetailLast) },
                        _react2.default.createElement(
                            'a',
                            { 'data-hook': 'rest-phone', style: _styles.linkStyle, href: 'tel:' + _wixrestUtils.PhoneUtils.validatePhone(phone, countryCode) },
                            phone
                        )
                    )
                )
            )
        )
    );
}

ContactMapDetails.propTypes = {
    i18n: _propTypes2.default.object,
    address: _propTypes2.default.string.isRequired,
    addressLink: _propTypes2.default.string,
    phone: _propTypes2.default.string,
    name: _propTypes2.default.string,
    fontFamily: _propTypes2.default.string,
    nameFontSize: _propTypes2.default.number,
    countryCode: _propTypes2.default.string
};

ContactMapDetails.displayName = 'ContactMapDetails';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ContactMapDetails.js
// module id = 468
// module chunks = 0